<script lang="ts">
    import AppSideBar from './components/AppSideBar.svelte';
    import UIElementList from './components/UIElementList.svelte';

    enum UiTabs {
        GENERAL_OPTIONS = 'GENERAL_OPTIONS',
        UI_ELEMENT_LIST = 'UI_ELEMENT_LIST',
    }

    // TODO: UIElementPages umbauen und verschönern
    let selectedTab = UiTabs.UI_ELEMENT_LIST;

</script>
<div id="right-side-bar" class="border border-b-slate-200 tabs">
    <a class="tab {selectedTab === UiTabs.UI_ELEMENT_LIST ? 'tab-lifted': ''}"
       on:click={() => selectedTab=UiTabs.UI_ELEMENT_LIST}>UI
        Elements</a>
    <a class="tab {selectedTab === UiTabs.GENERAL_OPTIONS ? 'tab-lifted': ''}"
       on:click={() => selectedTab=UiTabs.GENERAL_OPTIONS}>General options</a>
    {#if selectedTab === UiTabs.GENERAL_OPTIONS}
        <AppSideBar class="left-side-bar"></AppSideBar>
    {:else if selectedTab === UiTabs.UI_ELEMENT_LIST}
        <UIElementList></UIElementList>
    {/if}
</div>
